import { render, staticRenderFns } from "./EventsOverview.vue?vue&type=template&id=2f7cf6d1&scoped=true&"
import script from "./EventsOverview.vue?vue&type=script&lang=js&"
export * from "./EventsOverview.vue?vue&type=script&lang=js&"
import style0 from "./EventsOverview.vue?vue&type=style&index=0&id=2f7cf6d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7cf6d1",
  null
  
)

export default component.exports